// Compact interactive toggle used on Dashboard / DayView / History rows.
// Renders an actual shadcn Switch + a Test/Réel label. Clicking the switch flips
// the stock status via PATCH /api/stocks/{id}. The outer wrapper stops event
// propagation to prevent the parent <Link>/<button> from navigating.
import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export default function StatusToggle({ stock, onChanged }) {
  const initial = (stock.status || "test").toLowerCase() === "real";
  const [isReal, setIsReal] = useState(initial);
  const [busy, setBusy] = useState(false);

  const toggle = async (checked) => {
    if (busy) return;
    const prev = isReal;
    setIsReal(checked);
    setBusy(true);
    try {
      const r = await api.patch(`/stocks/${stock.id}`, { status: checked ? "real" : "test" });
      onChanged?.(r.data);
      toast.success(`${stock.symbol} → ${checked ? "Réel" : "Test"}`);
    } catch (err) {
      setIsReal(prev);
      toast.error("Impossible de basculer", { description: err?.response?.data?.detail || String(err) });
    } finally { setBusy(false); }
  };

  const stop = (e) => { if (e) { e.stopPropagation(); e.preventDefault(); } };

  return (
    <span
      onClick={stop}
      onMouseDown={stop}
      className="inline-flex items-center gap-1.5 shrink-0"
      data-testid={`status-toggle-${stock.symbol}`}
    >
      <Switch
        checked={isReal}
        onCheckedChange={toggle}
        disabled={busy}
        className="scale-[0.7] origin-left data-[state=unchecked]:bg-white data-[state=unchecked]:border-neutral-300"
        data-testid={`status-switch-${stock.symbol}`}
      />
      <span
        onClick={(e) => { stop(e); toggle(!isReal); }}
        className={`text-[9px] font-mono-num uppercase tracking-widest cursor-pointer ${isReal ? "text-[#00E676]" : "text-[#FFCC00]"}`}
      >
        {isReal ? "Réel" : "Test"}
      </span>
    </span>
  );
}
